import { toast } from 'react-toastify';

import { MAX_FILE_SIZE, MAX_IMAGE_SIZE, MAX_VIDEO_SIZE } from '../../../../../contants/enums';

const FILE_UPLOAD_LIMITS = {
    Image: {
        maxSizeMb: MAX_IMAGE_SIZE,
    },
    File: {
        maxSizeMb: MAX_FILE_SIZE,
    },
    AudioFile: {
        maxSizeMb: MAX_VIDEO_SIZE,
    },
};

export const validateFormFileUpload = (file, fileType) => {
    try {
        if (!file) {
            return true;
        }

        const config = FILE_UPLOAD_LIMITS[fileType];
        if (!config) {
            return true;
        }

        if (file.size <= config.maxSizeMb * 1024 * 1024) {
            return true;
        }

        toast.warn(`${fileType} must be less than ${config.maxSizeMb} MB in size`);
        return false;
    } catch (error) {
        console.error('validateFormFileUpload:', error);
        // In case of an error during validation, we allow the upload
        return true;
    }
};
